import { Box, makeStyles, styled, Typography } from "@material-ui/core";
import { Button } from "components";
import { Drawer } from "shared";

export const useStyles = makeStyles({
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "1rem"
  },
  addButton: {
    width: "9rem"
  }
});

export const StyledDrawer = styled(Drawer)(({ theme }) => ({
  "& .MuiPaper-root": {
    width: "32rem",
    [theme.breakpoints.down("sm")]: {
      width: "100%"
    }
  }
}));

export const FormContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  flexGrow: 1
});

export const FormTitle = styled(Typography)({
  fontFamily: "Inter",
  fontSize: "1rem",
  fontWeight: 600,
  color: "#353535"
});

export const Actions = styled(Box)({
  display: "flex",
  gap: "0.75rem",
  marginTop: "0.5rem"
});

export const SaveButton = styled(Button)({
  minWidth: "7rem"
});
